<template>
  <div>
    <el-autocomplete v-model="typedText"
                     :fetch-suggestions="querySearchAsync"
                     placeholder=""
                     @select="handleSelect"></el-autocomplete>
    <br>
    <el-tag v-for="tag in selectedUsers"
            :key="tag.id"
            closable
            @close="handleClose(tag)">
      {{tag.value}}
    </el-tag>
  </div>
</template>

<script>
function sortArrayByName(a, b) {
  var nameA = a.value.toUpperCase();
  var nameB = b.value.toUpperCase();
  if (nameA < nameB) {
    return -1;
  } else if (nameA > nameB) {
    return 1;
  } else {
    return 0;
  }
}

export default {
  created() {
    this.bus.$on('clearData', () => {
      this.typedText = '';
      this.users = this.getUsers();
      this.selectedUsers = [];
    });
  },
  data() {
    return {
      typedText: '',
      users: [],
      selectedUsers: [],
    };
  },
  props: ['bus'], // The bus is from mail/Index
  watch: {
    selectedUsers() {
      this.$emit('updateSelectAuthor', this.selectedUsers.map(user => user.id));
    },
  },
  methods: {
    querySearchAsync(queryString, cb) {
      var users = this.users;
      var results = queryString
        ? users.filter(this.createStateFilter(queryString))
        : users.sort(sortArrayByName);
      cb(results);
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1
        );
      };
    },
    handleSelect(user) {
      this.selectedUsers.push(user);
      this.typedText = '';
      this.users = this.users.filter(u => u.id != user.id);
    },
    handleClose(user) {
      this.selectedUsers = this.selectedUsers.filter(u => u.id != user.id);
      this.users.push(user);
      this.users.sort(sortArrayByName);
    },
    getUsers() {
      var datas = [];
      this.axios({
        url: 'users?page=0',
        methods: 'get',
      }).then(res => {
        var authors = res.data.results;
        for (let i = 0; i < authors.length; i++) {
          datas.push({
            id: authors[i].id,
            value: authors[i].book_name,
          });
        }
      });
      return datas;
    },
  },
  mounted() {
    this.users = this.getUsers();
  },
};
</script>

<style lang="scss" scoped>
.el-autocomplete {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/mail/UserPicklist.vue